/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Result, UserDTO } from '../../interfaces';
import { Api } from './axios-config/ApiConfig';
import { GenericService } from './GenericService';

const AuthenticateAsync = async (user: any): Promise<any | Error> => {
    try {
        const { data } = await Api.post('/authsphere/api/user/AuthenticateAsync', user);
        if (data) {
            return data;
        }
        return new Error('Enable to user authenticate. Contact the administrator.');
    } catch (error) {
        console.error(error);
        return new Error((error as { mesage: string }).mesage || 'Enable to user authenticate. Contact the administrator');
    }
};

export const UserService = {
    AuthenticateAsync
};

export const UserGetAll = async (
    companyId: string,
    setList: (value: UserDTO[]) => void,
    showMessage: (message: string, type: 'error' | 'info' | 'success' | 'warning') => void
) => {
    try {
        const filter = {
            companyId: companyId,
        };
        const result: Result<UserDTO[]> = await GenericService.GetAllAsync(filter, 'authsphere.user');

        if (result instanceof Error) { throw new Error(result.message); }

        if (result.code === 200) {

            setList(result.value);

        } else {
            showMessage(result.info, 'warning');
        }
    } catch (error) {
        showMessage(String(error), 'error');
    }
};